import { Reveal } from "./Reveal";

export const SectionHeading = ({ number, eyebrow, title, accent, after, sub, dark = false }) => (
    <Reveal className="max-w-2xl">
        <p
            className={`flex items-center gap-3 text-xs font-bold uppercase tracking-[0.3em] ${
                dark ? "text-teal-300" : "text-teal-accent"
            }`}
        >
            <span className="font-display text-sm italic tracking-normal">{number}</span>
            <span className={`h-px w-10 ${dark ? "bg-teal-300/50" : "bg-teal-600/40"}`} />
            {eyebrow}
        </p>
        <h2
            className={`mt-5 font-display text-4xl font-light leading-[1.08] sm:text-5xl ${
                dark ? "text-[#f8f6f0]" : "text-ink"
            }`}
        >
            {title}{" "}
            {accent && <em className={`font-medium ${dark ? "text-teal-300" : "text-teal-accent"}`}>{accent}</em>}
            {after && <> {after}</>}
        </h2>
        {sub && (
            <p className={`mt-5 text-base leading-relaxed md:text-lg ${dark ? "text-slate-300" : "text-slate-600"}`}>
                {sub}
            </p>
        )}
    </Reveal>
);
